export const requestTokenRoutes = [
  {
    path: '/solicitar-token',
    name: 'RequestToken',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true
    },
    component: () => import(/* webpackChunkName: 'request-token-page' */ 'views/RequestTokenPage')
  }
]
